import type { WorkId } from '../../../../../types/WorkId'
import { getWindowSearchParams, isServerSide } from '../../../../../utils/global'

export type ParsedParameters = {
  workEntityIds: WorkId[]
  isCareAgent: boolean
  editSource?: string
}

export const parseQueryParameters = (): ParsedParameters => {
  const parsedParameters: ParsedParameters = {
    workEntityIds: [],
    isCareAgent: false,
  }

  if (isServerSide()) return parsedParameters

  const searchParams = getWindowSearchParams()
  for (const [key, value] of searchParams.entries()) {
    if (key.toLowerCase() === 'workid') {
      parsedParameters.workEntityIds.push(value as WorkId)
    } else if (key.toLowerCase() === 'careagent') {
      parsedParameters.isCareAgent = /(^$)|(^true$)|(^1$)/i.test(value)
    } else if (key.toLowerCase() === 'editsource') {
      parsedParameters.editSource = value
    }
  }

  return parsedParameters
}

export const getQueryParam = (param: string): string | null => {
  if (isServerSide()) return null
  const searchParams = getWindowSearchParams()

  for (const [key, value] of searchParams.entries()) {
    if (key.toLowerCase() === param.toLowerCase()) {
      return value
    }
  }
  return null
}
